var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 12.8C9.68366 12.8 10.4 13.5163 10.4 14.4C10.4 15.2837 9.68366 16 8.8 16C7.91634 16 7.2 15.2837 7.2 14.4C7.2 13.5163 7.91634 12.8 8.8 12.8ZM3.79299 10.4C4.89756 10.4 5.79299 11.2954 5.79299 12.4C5.79299 13.5046 4.89756 14.4 3.79299 14.4C2.68842 14.4 1.79299 13.5046 1.79299 12.4C1.79299 11.2954 2.68842 10.4 3.79299 10.4ZM13.0555 10.8C13.9391 10.8 14.6555 11.5163 14.6555 12.4C14.6555 13.2837 13.9391 14 13.0555 14C12.1718 14 11.4555 13.2837 11.4555 12.4C11.4555 11.5163 12.1718 10.8 13.0555 10.8ZM14.8 7.45483C15.4627 7.45483 16 7.99209 16 8.65483C16 9.31757 15.4627 9.85483 14.8 9.85483C14.1373 9.85483 13.6 9.31757 13.6 8.65483C13.6 7.99209 14.1373 7.45483 14.8 7.45483ZM2 4.8C3.10457 4.8 4 5.69543 4 6.8C4 7.90457 3.10457 8.8 2 8.8C0.895431 8.8 0 7.90457 0 6.8C0 5.69543 0.895431 4.8 2 4.8ZM14.2286 4.1658C14.6705 4.1658 15.0286 4.52397 15.0286 4.9658C15.0286 5.40763 14.6705 5.7658 14.2286 5.7658C13.7868 5.7658 13.4286 5.40763 13.4286 4.9658C13.4286 4.52397 13.7868 4.1658 14.2286 4.1658ZM6.4 0C7.72548 0 8.8 1.07452 8.8 2.4C8.8 3.72548 7.72548 4.8 6.4 4.8C5.07452 4.8 4 3.72548 4 2.4C4 1.07452 5.07452 0 6.4 0ZM12.4 2.4C12.6209 2.4 12.8 2.57909 12.8 2.8C12.8 3.02091 12.6209 3.2 12.4 3.2C12.1791 3.2 12 3.02091 12 2.8C12 2.57909 12.1791 2.4 12.4 2.4Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerWhite);
export default __webpack_public_path__ + "static/media/spinnerWhite.cebff76c193f2aaa954c2f72de6790b2.svg";
export { ForwardRef as ReactComponent };